// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"fY-z","sponsoredTooltipWrapper":"gY-z","sponsoredTooltip":"hY-z","newCard":"iY-z"};